import React from "react";
import classes from "./ChatContainer.module.scss";

const ChatContainer = ({ leftArea, rightArea }) => {
  return (
    <div className={classes.chatContainer}>
      <div className={classes.leftArea}>{leftArea}</div>
      <div className={classes.rightArea}>{rightArea}</div>
    </div>
  );
};

export default ChatContainer;
